<template>
  <div class="success-wrap">
    <div class="content">
      <img src="../../assets/image/Success/success.png"/>
      <p>您已预约成功，</p>
      <p>我们会在3日内与您取得联系</p>
      <button @click="submit">完成</button>
    </div>
  </div>
</template>

<script>
  import common from '../../utils/common'
  import constants from '../../utils/constants'
    export default {
      name: "success",
      mounted() {
        window.scrollTo(0, 0)
        const that = this
        that.$nextTick(function () {
          if(!common.isEmpty(common.getUrlKey('type'))){
            constants.ZZC_SHAREINFO.link = constants.ZZC_SHAREINFO.link + '?type=' + common.getUrlKey('type')
          }
          common.wxShare(that, constants.ZZC_SHAREINFO)
        });
      },
      methods: {
        submit() {
          const that = this
          if(!common.isEmpty(common.getUrlKey('type'))){
            common.redirect(that, 'zzc?type=' + common.getUrlKey('type'))
          }else {
            common.redirect(that, 'zzc')
          }
        }
      }
    }
</script>

<style scoped>
  .success-wrap {
    margin: 0 auto;
    max-width: 7.50rem;
    min-width: 3.20rem;
    position: relative;
    display: flex;
    align-items: flex-end;
    font-size: 0;
    width: 100%;
    height: 100vh;
    text-align: center;
    background-color: #000;
  }
  .success-wrap > .content {
    margin-bottom: 3.2rem;
    width: 100%;
    font-size: 0;
  }

  .content > img {
    margin: 0 auto;
    margin-bottom: 0.39rem;
    width: 1.26rem;
    height: 1.26rem;
  }

  .content > p {
    font-size: 0.38rem;
    color: #fff;
    text-align: center;
    line-height: 0.69rem;
  }

  .content > button {
    margin-top: 2.88rem;
    width: 5.90rem;
    height: 0.9rem;
    line-height: 0.9rem;
    font-size: 0.30rem;
    color: #fff;
    border-radius: 0.08rem;
    border-width: 0;
    background-color: #A71023;
    outline: none;
  }


</style>



// WEBPACK FOOTER //
// src/components/Promotion/Success.vue